<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.375"
      height="10.064"
      viewBox="0 0 14.375 10.064"
      class="scaling-svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M7.205,10.064C2.987,10.064.543,6.171.1,5.39a.722.722,0,0,1,0-.715C.709,3.6,3.022.1,6.994,0c.071,0,.142,0,.212,0,4.179,0,6.627,3.894,7.076,4.674a.727.727,0,0,1,0,.715c-.615,1.07-2.929,4.57-6.9,4.671ZM7.163,1.438l-.133,0A5.779,5.779,0,0,0,3.495,2.83a9.4,9.4,0,0,0-1.933,2.2c.711,1.081,2.685,3.6,5.661,3.6h.124c2.916-.075,4.795-2.535,5.467-3.589C12.1,3.955,10.132,1.438,7.163,1.438Zm.025,6.11A2.516,2.516,0,1,1,9.7,5.032,2.519,2.519,0,0,1,7.188,7.548Zm0-3.595A1.078,1.078,0,1,0,8.267,5.032,1.079,1.079,0,0,0,7.188,3.954Z"
        transform="translate(-0.001 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PreviewIcon extends Vue {}
</script>

<style>
</style>
